/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";

export const Eyes = ({ className }) => {
  return (
    <svg
      className={`eyes ${className}`}
      fill="none"
      height="13"
      viewBox="0 0 34 13"
      width="34"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        className="rect"
        fill="#EDB98A"
        height="12.1"
        transform="translate(0.772461 0.291016)"
        width="32.6667"
      />

      <ellipse
        className="ellipse-33"
        cx="9.52246"
        cy="6.34141"
        fill="black"
        fillOpacity="0.6"
        rx="1.75"
        ry="1.65"
      />

      <path
        className="path"
        clipRule="evenodd"
        d="M21.3672 7.15331C21.8272 6.07577 22.983 5.26944 24.3893 5.17673C25.7905 5.08434 27.0502 5.72626 27.6671 6.72688C27.8504 7.02412 27.6408 7.29108 27.3966 7.1196C26.6406 6.58854 25.6011 6.29429 24.4776 6.36836C23.3894 6.44011 22.4301 6.8438 21.7618 7.43725C21.5174 7.65423 21.2327 7.46848 21.3672 7.15331Z"
        fill="black"
        fillOpacity="0.6"
        fillRule="evenodd"
      />
    </svg>
  );
};
